var _Suspense;
import { lazy, Suspense } from 'react';
import { useIsClient } from '@crehana/react-hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var CookiesBanner = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "crehana-web-cb" */"./CookiesBanner");
});
export var LazyCookiesBanner = function LazyCookiesBanner() {
  var isClient = useIsClient();
  if (!isClient) {
    return null;
  }
  return _Suspense || (_Suspense = /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(CookiesBanner, {})
  }));
};
export default LazyCookiesBanner;